module.exports = __webpack_public_path__ + "static/media/vse_DB703.5e10555d.jpg";